module.exports = __webpack_public_path__ + "img/8.addf21a3.jpg";